export interface IntegrationReadiness {
  platform: string;
  status: string;
  liveFinancialFeedProven?: boolean | null;
  historyImported?: boolean | null;
}

export const BUYGOODS_PENDING_LABEL = "Waiting for first sale";
export const BUYGOODS_HISTORY_IMPORTED_LABEL = "History imported";

export function isImportedBuyGoodsHistory(integration: IntegrationReadiness): boolean {
  return integration.platform === "buygoods"
    && integration.status === "active"
    && integration.liveFinancialFeedProven !== true
    && integration.historyImported === true;
}

export function isPendingBuyGoodsConnection(integration: IntegrationReadiness): boolean {
  return integration.platform === "buygoods"
    && integration.status === "active"
    && integration.liveFinancialFeedProven !== true
    && integration.historyImported !== true;
}

export function isReadyConnection(integration: IntegrationReadiness): boolean {
  return integration.status === "active" && !isPendingBuyGoodsConnection(integration);
}
